import { GridApi } from 'ag-grid-community';
import { useUpdateCustomerCompanyMutation } from 'queries/account';
import { useCallback } from 'react';
import { UpdaterFunction } from './columns';

interface Props {
  gridApi?: GridApi;
}
interface Result {
  updateCustomerCompany: UpdaterFunction;
}

export const useGridUpdater = ({ gridApi }: Props): Result => {
  const { mutateAsync } = useUpdateCustomerCompanyMutation();
  const updateCustomerCompany: UpdaterFunction = useCallback(
    async ({ companyId, payload, field, from }) => {
      return mutateAsync({ companyId, payload }).catch(() => {
        const row = gridApi?.getRowNode(companyId.toString());

        if (row != null) {
          row?.updateData({
            ...row?.data,
            [field.fieldName]: from,
          });
        }
      });
    },
    [gridApi, mutateAsync],
  );

  return {
    updateCustomerCompany,
  };
};
